import {cn} from '../../lib/utils';

import type {ComponentProps} from 'react';

function Textarea({className, ...props}: ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'input-base py-3 min-h-[100px] field-focus field-error field-disabled',
        className
      )}
      {...props}
    />
  );
}

export {Textarea};
